import { useEffect, useState, useContext } from "react";
import ImageUploader from "../../common/ImageUploader";
import {
  Flex,
  Form,
  Steps,
  Table,
  Typography,
  Button,
  Skeleton,
  Col,
  Row,
  Input,
  Select,
  Space,
  Tooltip,
} from "antd";
import CustomFormItems from "../../common/CustomFormItems";
import { IndexContext } from "../../../context/IndexContext";
import useFetch from "../../../hooks/useFetch";
import { backend_url, FORM_REQUIRED } from "../../../configs/configs";
import "../../../styles/Configuration/NewDeviceForm.css";

const parameterSelection = [
  {
    key: 1,
    Name: "Line Voltage",
    children: [
      {
        Name: "Line 1",
        key: "V12",
        GroupName: "Line Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Line 2",
        key: "V23",
        GroupName: "Line Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Line 3",
        key: "V31",
        GroupName: "Line Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Average",
        key: "VLLavg",
        GroupName: "Line Voltage",
        Unit: "V",
        DataType: "float",
      },
    ],
  },
  {
    key: 2,
    Name: "Phase Voltage",
    children: [
      {
        Name: "Phase 1",
        key: "V1",
        GroupName: "Phase Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "V2",
        GroupName: "Phase Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "V3",
        GroupName: "Phase Voltage",
        Unit: "V",
        DataType: "float",
      },
      {
        Name: "Average",
        key: "VLNavg",
        GroupName: "Phase Voltage",
        Unit: "V",
        DataType: "float",
      },
    ],
  },
  {
    key: 3,
    Name: "Current",
    children: [
      {
        Name: "Phase 1",
        key: "I1",
        GroupName: "Current",
        Unit: "A",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "I2",
        GroupName: "Current",
        Unit: "A",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "I3",
        GroupName: "Current",
        Unit: "A",
        DataType: "float",
      },
      {
        Name: "Average",
        key: "Iavg",
        GroupName: "Current",
        Unit: "A",
        DataType: "float",
      },
    ],
  },
  {
    key: 4,
    Name: "Power Factor",
    children: [
      {
        Name: "Phase 1",
        key: "PF1",
        GroupName: "Power Factor",
        Unit: "",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "PF2",
        GroupName: "Power Factor",
        Unit: "",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "PF3",
        GroupName: "Power Factor",
        Unit: "",
        DataType: "float",
      },
      {
        Name: "Average",
        key: "PFavg",
        GroupName: "Power Factor",
        Unit: "",
        DataType: "float",
      },
    ],
  },
  {
    key: 5,
    Name: "Active Power",
    children: [
      {
        Name: "Phase 1",
        key: "kW1",
        GroupName: "Active Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "kW2",
        GroupName: "Active Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "kW3",
        GroupName: "Active Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Total",
        key: "kWT",
        GroupName: "Active Power",
        Unit: "kW",
        DataType: "float",
      },
    ],
  },
  {
    key: 6,
    Name: "Apparent Power",
    children: [
      {
        Name: "Phase 1",
        key: "kVA1",
        GroupName: "Apparent Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "kVA2",
        GroupName: "Apparent Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "kVA3",
        GroupName: "Apparent Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Total",
        key: "kVAT",
        GroupName: "Apparent Power",
        Unit: "kW",
        DataType: "float",
      },
    ],
  },
  {
    key: 7,
    Name: "Reactive Power",
    children: [
      {
        Name: "Phase 1",
        key: "kVAR1",
        GroupName: "Reactive Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 2",
        key: "kVAR2",
        GroupName: "Reactive Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Phase 3",
        key: "kVAR3",
        GroupName: "Reactive Power",
        Unit: "kW",
        DataType: "float",
      },
      {
        Name: "Total",
        key: "kVART",
        GroupName: "Reactive Power",
        Unit: "kW",
        DataType: "float",
      },
    ],
  },
  {
    key: 8,
    Name: "Active Energy",
    children: [
      {
        Name: "Import",
        key: "kWh_I",
        GroupName: "Active Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Export",
        key: "kWh_E",
        GroupName: "Active Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Nett",
        key: "kWh_N",
        GroupName: "Active Energy",
        Unit: "kWh",
        DataType: "float",
      },
    ],
  },
  {
    key: 9,
    Name: "Apparent Energy",
    children: [
      {
        Name: "Import",
        key: "kVAh_I",
        GroupName: "Apparent Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Export",
        key: "kVAh_E",
        GroupName: "Apparent Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Nett",
        key: "kVAh_N",
        GroupName: "Apparent Energy",
        Unit: "kWh",
        DataType: "float",
      },
    ],
  },
  {
    key: 10,
    Name: "Reactive Energy",
    children: [
      {
        Name: "Import",
        key: "kVARh_I",
        GroupName: "Reactive Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Export",
        key: "kVARh_E",
        GroupName: "Reactive Energy",
        Unit: "kWh",
        DataType: "float",
      },
      {
        Name: "Nett",
        key: "kVARh_N",
        GroupName: "Reactive Energy",
        Unit: "kWh",
        DataType: "float",
      },
    ],
  },
];

const columns = [
  {
    title: "Name",
    dataIndex: "Name",

    key: "Name",
    onCell: (record, index) => {
      if (record.children) return { colSpan: 2 };
      else return { colSpan: 1 };
    },
  },
  {
    title: "Tag Key",
    dataIndex: "key",
    key: "key",
    editable: true,
    onCell: (record, index) => {
      if (record.children) return { colSpan: 0 };
      else return { colSpan: 1 };
    },
    render: (text, record) => {
      // if the record is a parent, don't display the tag key
      return record.children ? "" : text;
    },
  },
];

const layout = {
  labelCol: {
    span: 24,
    padding: 0,
  },
  wrapperCol: {
    span: 24,
  },
};

const { Text } = Typography;

export default function DeviceForm(props) {
  const {
    siteID,
    mode,
    setIsPowerMeterFormModalOpen,
    refreshTable,
    initialValues = null,
  } = props;
  const [deviceID, setDeviceID] = useState(null);
  const [fileList, setFileList] = useState([]);

  const [step, setStep] = useState(0);
  const [form] = Form.useForm();
  const [parameters, setParameters] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false);

  const { messageApi, notificationApi } = useContext(IndexContext);
  const [fetchWrapper] = useFetch();

  const [meterTypeList, setMeterTypeList] = useState([]);

  const [meterBrandList, setMeterBrandList] = useState([]);
  const [meterBrandSelected, setMeterBrandSelected] = useState(null);

  const [meterModelList, setMeterModelList] = useState([]);

  const [areaList, setAreaList] = useState([]);
  const [areaSelected, setAreaSelected] = useState(null);

  const [seuList, setSeuList] = useState([]);
  const [seuSelected, setSeuSelected] = useState(null);

  const [inputPowerMeterData, setInputPowerMeterData] = useState({});

  // table scrollable height
  const [tableHeight, setTableHeight] = useState(622);
  const [stepHeight, setStepHeight] = useState(32);

  const formItem = [
    {
      name: "Name",
      label: "Name",
      type: "input",
      maxLength: 20,
      rules: [
        { required: FORM_REQUIRED, message: "Please enter device name." },
        {
          validator: (_, value, callback) => {
            checkUniquePowerMeterName(value, callback);
          },
        },
      ],
    },
    {
      name: "Key",
      label: "Device Key",
      type: "input",
      maxLength: 20,
      rules: [
        { required: FORM_REQUIRED, message: "Please enter device key." },
        {
          validator: (_, value, callback) => {
            checkUniquePowerMeterKey(value, callback);
          },
        },
      ],
      show: mode === "edit" ? true : false, // only show device key in "edit" mode
    },
    {
      name: "DeviceTypeID",
      label: "Device Type",
      rules: [
        { required: FORM_REQUIRED, message: "Please select device type." },
      ],
      type: "select",
      options: meterTypeList,
    },
    {
      name: "BrandID",
      label: "Brand",
      rules: [
        { required: FORM_REQUIRED, message: "Please select device brand." },
      ],
      type: "select",
      options: meterBrandList,
      onChange: (value) => {
        setMeterBrandSelected(value);

        if (mode === "edit") {
          form.setFieldValue("ModelID", null); // set ModelID to null so that previous ModelID get from initial values will be reset
        }
      },
    },
    {
      name: "ModelID",
      label: "Model",
      rules: [
        { required: FORM_REQUIRED, message: "Please select device model." },
      ],
      type: "select",
      options: meterModelList,
      disabled: meterBrandSelected === null || meterModelList.length === 0,
    },
    {
      name: "AreaID",
      label: "Area",
      type: "select",
      disabled: false,
      options: areaList,
      onChange: (value) => {
        setAreaSelected(value);
        form.setFieldValue("IsAreaSource", null);
      },
    },
    {
      name: "IsAreaSource",
      label:
        "Do you want to include this device in total energy usage calculation for the area you select above?",
      type: "select",
      disabled: areaSelected ? false : true,
      rules: [
        {
          required: areaSelected ? true : false,
          message:
            "You need to select whether you want to include this device in total energy usage calculation for the area you select above.",
        },
      ],
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    {
      name: "SeuID",
      label: "SEU",
      type: "select",
      options: seuList,
      onChange: (value) => {
        setSeuSelected(value);
        form.setFieldValue("IsSeuSource", null);
      },
    },
    {
      name: "IsSeuSource",
      label:
        "Do you want to include this device in total energy usage calculation for the SEU you select above?",
      type: "select",
      disabled: seuSelected ? false : true,
      rules: [
        {
          required: seuSelected ? true : false,
          message:
            "You need to select whether you want to include this device in total energy usage calculation for the SEU you select above.",
        },
      ],
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setParameters(selectedRows?.filter((row) => "GroupName" in row));
    },
  };

  /* API to get meter type selection */
  function getMeterType() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getMeterType",
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setMeterTypeList(fetch_output.meter_type_list);
        }
        setLoading(false);
      },
    });
  }

  /* API to get meter brand selection */
  function getMeterBrand() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getMeterBrand",
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setMeterBrandList(fetch_output.meter_brand_list);
        }
        setLoading(false);
      },
    });
  }

  /* API to get meter model selection */
  function getMeterModel() {
    setMeterModelList([]);
    fetchWrapper({
      endpoint_url: "site_management/getMeterModel",
      body: {
        brand_id: meterBrandSelected,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setMeterModelList(fetch_output.meter_model_list);
        }
      },
    });
  }

  /* API to get area selection */
  function getAreaList() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getAreaList",
      body: {
        site_id: siteID,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setAreaList(fetch_output.area_list);
        }
        setLoading(false);
      },
    });
  }

  /* API to get seu selection */
  function getSeuList() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getSeuList",
      body: {
        site_id: siteID,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          setSeuList(fetch_output.seu_list);
        }
        setLoading(false);
      },
    });
  }

  /* API to get device parameter details */
  function getPowerMeterParameterDetails(power_meter_id) {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getPowerMeterParameterDetails",
      body: {
        power_meter_id: power_meter_id,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setSelectedRowKeys(fetch_output.row_key_list);
          setParameters(fetch_output.parameter_list);
        }
      },
    });
  }

  /* API to add device data */
  function addPowerMeterData() {
    setLoadingSubmitButton(true);

    fetchWrapper({
      endpoint_url: "site_management/addPowerMeterData",
      body: {
        site_id: siteID,
        power_meter_data: inputPowerMeterData,
        parameter_data: parameters,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsPowerMeterFormModalOpen(false);
          form.resetFields();
          setMeterBrandSelected(null);
          setSelectedRowKeys([]);
          setParameters([]);
          refreshTable();
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
      },
    });
  }

  function addPowerMeter() {
    const value = form.getFieldsValue([
      "Name",
      "DeviceTypeID",
      "BrandID",
      "ModelID",
      "AreaID",
      "IsAreaSource",
      "SeuID",
      "IsSeuSource",
    ]);
    setLoadingSubmitButton(true);
    let form_data = new FormData();
    Object.keys(value).forEach((key) => {
      if (value[key] ?? null != null) {
        form_data.append(key, value[key] ?? null);
      }
    });

    if (fileList.length > 0 && fileList[0].originFileObj) {
      form_data.append("image", fileList[0].originFileObj);
    }

    fetchWrapper({
      endpoint_url: "site_management/addPowerMeter",
      set_content_type_header: false,
      params: {
        SiteID: siteID,
        ...(deviceID != null && { DeviceID: deviceID }),
      },
      body: form_data,
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        setDeviceID(response.data?.ID);
        addPowerMeterParameter(response.data?.ID);
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
        setLoadingSubmitButton(false);
      },
      onFetchError: (error) => {
        setLoadingSubmitButton(false);
      },
    });
  }

  function addPowerMeterParameter(device_id) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "site_management/addPowerMeterParameter",
      params: { DeviceID: device_id },
      body: { Parameters: parameters },
      onSuccess: (response) => {
        notificationApi.success({
          message: response.message,
        });
        setIsPowerMeterFormModalOpen(false);
        refreshTable();
      },
      onFinish: () => {
        setLoadingSubmitButton(false);
      },
    });
  }

  /* API to edit device data */
  function editPowerMeterData() {
    setLoadingSubmitButton(true);

    fetchWrapper({
      endpoint_url: "site_management/editPowerMeterData",
      body: {
        power_meter_id: initialValues.ID,
        power_meter_data: inputPowerMeterData,
        parameter_data: parameters,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsPowerMeterFormModalOpen(false);
          form.resetFields();
          setMeterBrandSelected(null);
          setAreaSelected(null);
          setSeuSelected(null);
          setFileList(null);
          setSelectedRowKeys([]);
          setParameters([]);
          refreshTable();
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
      },
    });
  }

  /* API to check whether device name is unique */
  function checkUniquePowerMeterName(power_meter_name, callback) {
    fetchWrapper({
      endpoint_url: "site_management/checkUniquePowerMeterName",
      body: {
        site_id: siteID,
        power_meter_id: initialValues ? initialValues.ID : null,
        power_meter_name: power_meter_name ? power_meter_name : "",
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          if (fetch_output.is_unique === true) {
            callback(); // No error, so pass an empty callback
          } else {
            callback(
              "Device name already exists. Please input another device name."
            );
          }
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  /* API to check whether device key is unique */
  function checkUniquePowerMeterKey(power_meter_key, callback) {
    fetchWrapper({
      endpoint_url: "site_management/checkUniquePowerMeterKey",
      body: {
        site_id: siteID,
        power_meter_id: initialValues.ID,
        power_meter_key: power_meter_key ? power_meter_key : "",
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          if (fetch_output.is_unique === true) {
            callback(); // No error, so pass an empty callback
          } else {
            callback(
              "Device key already exists. Please input another device key."
            );
          }
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  function nextStep(value) {
    //addPowerMeter(value);
    setStep(1);
  }

  function handleSubmit() {
    addPowerMeter();
  }

  const clearForm = () => {
    form.resetFields();
    setMeterBrandSelected(null);
    setAreaSelected(null);
    setSeuSelected(null);
    setFileList(null);
  };

  useEffect(() => {}, [fileList]);

  useEffect(() => {
    getMeterType();
    getMeterBrand();
  }, []);

  useEffect(() => {
    if (siteID) {
      getAreaList();
      getSeuList();
    }
  }, [siteID]);

  useEffect(() => {
    if (meterBrandSelected) {
      getMeterModel();
    }
  }, [meterBrandSelected]);

  useEffect(() => {
    if (mode === "edit") {
      if (initialValues) {
        getPowerMeterParameterDetails(initialValues.ID);

        form.setFieldsValue(initialValues);

        setMeterBrandSelected(initialValues.BrandID); // set brand selected so that meter model list is updated

        // set AreaID and SeuID to null if N/A
        if (initialValues.AreaID === "N/A") {
          form.setFieldValue("AreaID", null);
        } else if (initialValues.AreaID !== "N/A") {
          setAreaSelected(initialValues.AreaID); // set area selected so that IsAreaSource is not disabled and the required field is set correctly
        }

        if (initialValues.SeuID === "N/A") {
          form.setFieldValue("SeuID", null);
        } else if (initialValues.SeuID !== "N/A") {
          setSeuSelected(initialValues.SeuID); // set seu selected so that IsSeuSource is not disabled and the required field is set correctly
        }
        setDeviceID(initialValues.ID);

        if (initialValues.ImagePath) {
          setFileList([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: `${backend_url}site_management/getDeviceImage?Path=${initialValues.ImagePath}`,
            },
          ]);
        }
      }
    }
  }, [mode, initialValues]);

  useEffect(() => {
    const stepResizeObserver = new ResizeObserver(() => {
      const stepElement = document.getElementById("Step");
      setStepHeight(stepElement?.offsetHeight);
    });
    const stepElement = document.getElementById("Step");
    stepResizeObserver.observe(stepElement);

    const FormAreaResizeObserver = new ResizeObserver(() => {
      const FormArea = document.getElementById("FormArea");
      setTableHeight(FormArea?.offsetHeight - 80 - 38 - 38);
    });
    const FormArea = document.getElementById("FormArea");
    FormAreaResizeObserver.observe(FormArea);

    return () => {
      stepResizeObserver.disconnect();
      FormAreaResizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="p-4" style={{ height: "100%" }}>
      <div id="Step">
        <Steps
          current={step}
          className="mb-4"
          items={[
            {
              title: "General",
            },
            {
              title: "Parameter Setting",
            },
          ]}
        />
      </div>
      <div
        id="FormArea"
        style={{
          height: `calc(100% - ${stepHeight}px - 54px)`,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "16px",
        }}
      >
        {step == 0 && (
          <>
            {loading ? (
              <Skeleton />
            ) : (
              <Form
                form={form}
                {...layout}
                onFinish={nextStep}
                scrollToFirstError
                autoComplete="off"
                style={{
                  height: "100%",
                  overflowY: "hidden",
                  overflowX: "hidden",
                }}
              >
                <Row
                  gutter={[24, 12]}
                  style={{
                    height: "calc(100% - 48px)",
                    overflow: "auto",
                  }}
                >
                  <Col flex="250px">
                    <Form.Item label="Image" className="mb-0">
                      <ImageUploader
                        size={250}
                        maxCount={1}
                        fileList={fileList}
                        onChange={(files) => {
                          setFileList(files);
                        }}
                      ></ImageUploader>
                    </Form.Item>
                  </Col>
                  <Col flex="auto">
                    <Form.Item
                      name={"Name"}
                      label={"Name"}
                      validateDebounce={100}
                      rules={[
                        {
                          required: true,
                          message: "Please enter device name.",
                        },
                        {
                          validator: (_, value, callback) => {
                            checkUniquePowerMeterName(value, callback);
                          },
                        },
                      ]}
                    >
                      <Input maxLength={50}></Input>
                    </Form.Item>
                    <Form.Item
                      name={"DeviceTypeID"}
                      label={"Device Type"}
                      rules={[
                        {
                          required: true,
                          message: "Please select device type.",
                        },
                      ]}
                    >
                      <Select options={meterTypeList}></Select>
                    </Form.Item>
                    <Form.Item
                      name={"BrandID"}
                      label={"Brand"}
                      rules={[
                        {
                          required: true,
                          message: "Please select device brand.",
                        },
                      ]}
                    >
                      <Select
                        options={meterBrandList}
                        onChange={(value) => {
                          setMeterBrandSelected(value);
                          form.setFieldValue("ModelID", null);
                        }}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                      name={"ModelID"}
                      label={"Model"}
                      rules={[
                        {
                          required: true,
                          message: "Please select device model.",
                        },
                      ]}
                    >
                      <Select
                        options={meterModelList}
                        disabled={
                          meterBrandSelected === null ||
                          meterModelList.length === 0
                        }
                      ></Select>
                    </Form.Item>
                    <Space.Compact block>
                      <Form.Item
                        name={"AreaID"}
                        label={"Area"}
                        style={{ width: "calc(100% - 180px)" }}
                      >
                        <Select
                          options={areaList}
                          allowClear
                          onChange={(value) => {
                            setAreaSelected(value);
                            form.setFieldValue(
                              "IsAreaSource",
                              value == null ? null : true
                            );
                          }}
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={" "}
                        style={{
                          width: 200,
                        }}
                      >
                        <Input
                          style={{
                            borderInline: 0,
                          }}
                          placeholder="Include in Calculation?"
                          disabled
                        ></Input>
                      </Form.Item>
                      <Form.Item
                        name={"IsAreaSource"}
                        label={" "}
                        style={{
                          width: 90,
                        }}
                      >
                        <Select
                          disabled={areaSelected == null}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                        ></Select>
                      </Form.Item>
                    </Space.Compact>
                    <Space.Compact block>
                      <Form.Item
                        name={"SeuID"}
                        label={
                          <Tooltip
                            placement="top"
                            title="Significant Energy Usage"
                          >
                            SEU
                          </Tooltip>
                        }
                        style={{ width: "calc(100% - 180px)" }}
                      >
                        <Select
                          options={seuList}
                          allowClear
                          onChange={(value) => {
                            setSeuSelected(value);
                            form.setFieldValue(
                              "IsSeuSource",
                              value == null ? null : true
                            );
                          }}
                        ></Select>
                      </Form.Item>
                      <Form.Item
                        label={" "}
                        style={{
                          width: 200,
                        }}
                      >
                        <Input
                          style={{
                            borderInline: 0,
                          }}
                          placeholder="Include in Calculation?"
                          disabled
                        ></Input>
                      </Form.Item>
                      <Form.Item
                        name={"IsSeuSource"}
                        label={" "}
                        style={{
                          width: 90,
                        }}
                      >
                        <Select
                          disabled={seuSelected == null}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                        ></Select>
                      </Form.Item>
                    </Space.Compact>
                  </Col>
                </Row>
                <Flex
                  justify="end"
                  align="center"
                  gap="middle"
                  className="mt-4"
                >
                  <Button type="default" onClick={() => clearForm()}>
                    Clear
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Next
                  </Button>
                </Flex>
              </Form>
            )}
          </>
        )}
        {step == 1 && (
          <>
            <div style={{ height: tableHeight + 76 }}>
              <Table
                columns={columns}
                dataSource={parameterSelection}
                pagination={false}
                scroll={{ y: tableHeight, x: true }}
                size="small"
                rowSelection={{
                  ...rowSelection,
                  checkStrictly: false,
                }}
                footer={() => (
                  <Text strong justify="right">
                    Selected Parameters - {parameters?.length}
                  </Text>
                )}
              ></Table>
            </div>
            <Flex
              justify="space-between"
              align="center"
              gap="middle"
              className="mt-4"
            >
              <Button
                onClick={() => {
                  setStep(step - 1);
                }}
              >
                Previous
              </Button>
              <Button
                type="primary"
                loading={loadingSubmitButton}
                onClick={() => {
                  // if (mode === "add") {
                  //   addPowerMeterData();
                  // } else {
                  //   editPowerMeterData();
                  // }
                  handleSubmit();
                }}
              >
                Submit
              </Button>
            </Flex>
          </>
        )}
      </div>
    </div>
  );
}
